import { useCalendarioAlocacaoTab } from "./use-calendario-alocacao-tab";
import { CalendarioAlocacaoTabView } from "./view-calendario-alocacao-tab";
import type { CalendarioAlocacaoTabProps } from "./types-calendario-alocacao-tab";

export function CalendarioAlocacaoTab(props: CalendarioAlocacaoTabProps) {
  const vm = useCalendarioAlocacaoTab(props);

  return <CalendarioAlocacaoTabView {...props} {...vm} />;
}

export type * from "./types-calendario-alocacao-tab";
